import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

export default class Tooltip extends Component {
  render() {
    return (
      <div
        className="tooltip-wrapper"
        data-tip={this.props.tip}
        data-place={this.props.place}
        data-delay-show={this.props.delayShow ? 1000 : 0}
        data-delay-hide={this.props.delayHide ? 1000 : 0}
        data-html={this.props.html}
      >
        {this.props.children}
        <ReactTooltip
          effect="solid"
        />
      </div>
    );
  }
}


Tooltip.propTypes = {
  tip: PropTypes.any,
  children: PropTypes.any,
  place: PropTypes.string,
  delayShow: PropTypes.bool,
  delayHide: PropTypes.bool,
  html: PropTypes.bool,
}

Tooltip.defaultProps = {
  html: false
}
